export const BUSE_ID = 2104
export const CARGO_ID = 2101
export const TRACTOR_ID = 2103
export const CARGO_LARGE_ID = 2102
